
import { useNavigate } from "react-router-dom";
import { HttpClient } from "../../../web-services/http-client";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function HomePage(props: { httpClient: HttpClient })
{
    const navigate = useNavigate();

    return (
        <div className="container" />
    );
}
